module.exports = __webpack_public_path__ + "files/b5a023f081636e2820b82f49681f3de6.png";